// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e165b90e","617":"b22f5312","847":"26bb7651"}[chunkId] + ".chunk.js";
};